import { render, staticRenderFns } from "./p_company005.vue?vue&type=template&id=731ea1a0&scoped=true&"
import script from "./p_company005.vue?vue&type=script&lang=js&"
export * from "./p_company005.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731ea1a0",
  null
  
)

export default component.exports